import React, { ChangeEvent, FC, useCallback } from "react";
import { DescriptionIcon } from "@components";
import { TextField } from "@mui/material";
import { textLengthValidator } from "@helpers";
import { setClass } from "@utils";
import { isMobile } from "react-device-detect";

interface IntervalBlockProp {
  description: string;
  isEdit: boolean;
  onUpdateMeeting: (property: "description", value: string) => void;
  showError: boolean;
  disabled: boolean;
}

export const DescriptionBlock: FC<IntervalBlockProp> = ({
  description,
  onUpdateMeeting,
  isEdit,
  showError,
  disabled,
}) => {
  const onDescriptionChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      onUpdateMeeting("description", event.target.value);
    },
    [onUpdateMeeting]
  );
  return (
    (isEdit || description.length !== 0) && (
      <div className="area description">
        <DescriptionIcon divClassName="description-icon" />
        {isEdit ? (
          <TextField
            className={setClass("description-field", isMobile && "mobile")}
            disabled={disabled}
            size="small"
            value={description}
            placeholder="Добавить описание"
            onChange={onDescriptionChange}
            variant="filled"
            error={
              showError &&
              description &&
              !textLengthValidator(description, 1024)
            }
            helperText={
              showError &&
              description &&
              !textLengthValidator(description, 1024) &&
              "Превышен максимальный размер поля в 1024 символов"
            }
            multiline
            minRows={1}
            maxRows={5}
          />
        ) : (
          <p className="description-field">{description}</p>
        )}
      </div>
    )
  );
};
